export const questions = [
  {
    text: "You're at a party where you don't know many people. What do you do?",
    options: [
      { text: "Introduce yourself to everyone and become the life of the party", type: "A" },
      { text: "Find a quiet corner and observe people before engaging", type: "B" },
      { text: "Look for someone who seems friendly and start a conversation", type: "C" }
    ]
  },
  {
    text: "When making important decisions, you typically:",
    options: [
      { text: "Trust your gut instinct and decide quickly", type: "A" },
      { text: "Analyze all possible outcomes thoroughly", type: "B" },
      { text: "Seek advice from trusted friends or family", type: "C" }
    ]
  },
  {
    text: "Your ideal weekend would be:",
    options: [
      { text: "Leading a group adventure or organizing an event", type: "A" },
      { text: "Reading a fascinating book or learning something new", type: "B" },
      { text: "Spending quality time with close friends or family", type: "C" }
    ]
  },
  {
    text: "When working on a team project, you usually:",
    options: [
      { text: "Take charge and delegate tasks to team members", type: "A" },
      { text: "Focus on research and provide detailed analysis", type: "B" },
      { text: "Support others and help maintain team harmony", type: "C" }
    ]
  },
  {
    text: "Under pressure, you tend to:",
    options: [
      { text: "Thrive and perform your best work", type: "A" },
      { text: "Stay calm and think through solutions systematically", type: "B" },
      { text: "Take time to process and prefer a steady approach", type: "C" }
    ]
  },
  {
    text: "Your friends would describe you as:",
    options: [
      { text: "Confident, ambitious, and inspiring", type: "A" },
      { text: "Intelligent, thoughtful, and reliable", type: "B" },
      { text: "Kind, patient, and a great listener", type: "C" }
    ]
  }
];

export const personalityTypes = {
  leader: {
    emoji: "🦁",
    title: "The Natural Leader",
    description: "You're a born leader with natural charisma and confidence. You inspire others and aren't afraid to take charge in challenging situations. Your decisive nature and ability to motivate people make you a powerful force in any team or organization.",
    funFact: "Only 8% of people have dominant leadership traits like yours!"
  },
  thinker: {
    emoji: "🧠",
    title: "The Deep Thinker",
    description: "You're an analytical mind who loves to understand how things work. You approach problems methodically and your thoughtful insights often lead to innovative solutions. Your wisdom and careful consideration make you a valued advisor to others.",
    funFact: "Your analytical thinking style is shared by many successful scientists and inventors!"
  },
  calm: {
    emoji: "🌊",
    title: "The Peaceful Soul",
    description: "You bring harmony and balance wherever you go. Your empathetic nature and patient approach help others feel heard and understood. You're the person friends turn to for comfort and wise counsel during difficult times.",
    funFact: "Your calming presence can actually reduce stress levels in people around you!"
  }
};